// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { DynamicPicklist } from '../'

import { QUERY_PRODUCT_NAMES_BY_FAMILY } from '../../queries'


export const ProductName = ({ value, family, onChange, disabled, inline }) => (
  <div className='slds-grid slds-wrap'>
    <div className="slds-col slds-size_1-of-1 sidebar__item__title">
      Product name
    </div>
    <div className="slds-col slds-size_3-of-4">
      <div className="sidebar__item__choice">
        <DynamicPicklist
          id='productName'
          query={QUERY_PRODUCT_NAMES_BY_FAMILY}
          field='name'
          params={{
            family: disabled
              ? undefined
              : family
          }}
          defaultValue='All'
          value={value === ''
            ? undefined
            : value
          }
          onChange={onChange}
          disabled={disabled}
          useFieldValue={true}
          inline={inline}
        />
      </div>
    </div>
  </div>
)

ProductName.propTypes = {
  value: PropTypes.string,
  family: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  inline: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/filter-combo-payment-family-name/ProductName.js